<template>
  <Suspense>
    <user-context />
    <template #fallback>
      <w-stack
        align-items="center"
        justify-content="center"
        full-width
        full-height
      >
        <w-spacer all="xlarge">
          <w-spinner />
        </w-spacer>
      </w-stack>
    </template>
  </Suspense>
  <modal-container />
  <toast-container />
</template>

<script setup lang="ts">
import { WSpacer, WSpinner, WStack } from '@dp-watson-web/components';

import { useLoadLanguages } from '@/features/i18n';
import { ModalContainer } from '@/plugins/modal';
import { ToastContainer } from '@/plugins/toast';
import { UserContext } from '@/shared/user-context';

useLoadLanguages();
</script>
